module.exports = __webpack_public_path__ + "static/media/tranquil_living_banner.37ea44a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/tranquil_living_banner.png
// module id = 533
// module chunks = 0